module.exports = {
}


// WEBPACK FOOTER //
// ./src/pages/resetPassword/i18n/locale.en.js